import { STOCK_URL, customAxios } from '../constants';
import { FETCH_COLORES, FETCH_LISTA_COLORES, CLEAR_COLORES,FETCH_COLORES_GET } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchColores(proformas) {
  const promises = [];
  proformas.map((proforma) => {
    const data = {
      codAreaVta: proforma.codAreaVta,
      codFamilia: proforma.codFamilia,
      codMarca: proforma.codMarca,
      codigoClausula: '999',
    };

    return (
    promises.push(
      customAxios.post(`${STOCK_URL}/maestros/colorPinturaSku/listar`, data).then(response => ({
        [proforma.nroProforma]: response.data.pinturaList,
      })),
    ));
  });

  const request = Promise.all(promises);

  return {
    type: FETCH_COLORES,
    payload: request,
  };
}

export function clearColores() {
  return {
    type: CLEAR_COLORES,
  };
}

export function fetchListaColores(proformas) {
  const promises = [];
  proformas.map((proforma) => {
    const data = {
      codAreaVta: proforma.codAreaVta,
      codFamilia: proforma.codFamiliaVeh,
      codMarca: proforma.codMarca,
      codigoClausula: '999',
    };

    return (
    promises.push(
      customAxios.post(`${STOCK_URL}/maestros/colorPinturaSku/listar`, data).then(response => ({
        [proforma.numProfVeh]: response.data.pinturaList,
      })),
    ));
  });

  const request = Promise.all(promises);

  return {
    type: FETCH_LISTA_COLORES,
    payload: request,
  };
}

export function fetchColoresGet(codAreaVta,codFamiliaVeh,codMarca) {
  const data = {
    codAreaVta: codAreaVta,
    codFamilia: codFamiliaVeh,
    codMarca: codMarca,
    codigoClausula: '999',
  };

  const request = customAxios.post(`${STOCK_URL}/maestros/colorPinturaSku/listar`,data);

  return {
    type: FETCH_COLORES_GET,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Colores.js